"use strict";
/*

SHORTHANDS:
$common      - compilator.common

*/
// Defines compilator global namespace.
var compilator = compilator || {};

compilator.common = {

  isCharacter: function (keyCode) {
    return keyCode == 32 || keyCode >= 48 && keyCode <= 90 || keyCode >= 96 && keyCode <= 111 || keyCode >= 186 && keyCode <= 192 || keyCode >= 219 && keyCode <= 222 || keyCode == 229;
  },
  ctrlVPressed: function (e) {
    e = e || window.event;
    var key = e.which || e.keyCode; // keyCode detection
    var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false); // ctrl detection

    if (key == 86 && ctrl) {
      return true;
    } 
    return false;
  },
  ctrlCPressed: function (e) {
    e = e || window.event;
    var key = e.which || e.keyCode; // keyCode detection
    var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false); // ctrl detection

    if (key == 67 && ctrl) {
      return true;
    }
    return false;
  },
  ctrlXPressed: function (e) {
    e = e || window.event;
    var key = e.which || e.keyCode; // keyCode detection
    var ctrl = e.ctrlKey ? e.ctrlKey : ((key === 17) ? true : false); // ctrl detection

    if (key == 88  && ctrl) {
      return true;
    }
    return false;
  },


  //Fires click event of a button when enterkey is pressed.
  clickOnEnterPress: function (event, buttonClientId) { //PressEnter()
    if (event.keyCode === 13) {
      $('#' + buttonClientId).click();
    }
  },


  isGuid: function (str) {
    const reg = /^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$/;
    return reg.test(str);
  },

  /* Returns true if arrow down key was typed otherwise false. */
  arrowDown: function (e) {
    const keyCode = e.keyCode || e.which,
          key = { left: 37, up: 38, right: 39, down: 40, enter: 13 };
    switch (keyCode) {
      case key.down:
        return true;
      case key.enter:
        return true;
    }
    return false;
  },

  /* Returns true if arrow up key was typed otherwise false. */
  arrowUp: function (e) {
    const keyCode = e.keyCode || e.which,
            arrow = { left: 37, up: 38, right: 39, down: 40 };
    switch (keyCode) {
      case arrow.up:
        return true;
    }
    return false;
  },
  /* Returns true if enter key was typed otherwise false. */
  enterPressed: function (e) {
      const keyCode = e.keyCode || e.which,
          keyDown = { enter: 13};
      switch (keyCode) {
      case keyDown.enter:
          return true;
      }
      return false;

  },
  telerikDateSelected: function (sender, args) {
    const control = sender;
    setTimeout(function () {
      control.get_dateInput().focus()
    }, 1);
  },

  togglePageSection: function (clickedElement, callbackFunction, initFunction) {

    if (initFunction) {
      const initPromise = Promise.resolve(window[initFunction](clickedElement));
      initPromise.then(function () {
        $common.runTogglePageSection(clickedElement, callbackFunction, initFunction);
      });
    }
    else {
      $common.runTogglePageSection(clickedElement, callbackFunction, initFunction);
    }
  },

  runTogglePageSection: function (clickedElement, callbackFunction, initFunction) {
    // Find elements
    const content = $($(clickedElement).parent().next(".PageSectionContent"));
    const horizontalRule = content.find("hr:first-of-type");
    let arrowIcon;
    let sectionHeader;

    if (!$(clickedElement).hasClass("k-icon")) {
      sectionHeader = $(clickedElement);
      arrowIcon = $(sectionHeader.prev());
    }
    else {
      arrowIcon = $(clickedElement);
      sectionHeader = $(clickedElement).next();
    }

    // Unbind click functions while animating
    arrowIcon.prop('onclick', null).off('click');
    sectionHeader.prop('onclick', null).off('click');

    // Animate
    if (content.is(":visible")) {
      arrowIcon.toggleClass("rotate-180");
      horizontalRule.animate({ opacity: 0 }, 1, function () {
        content.slideUp("fast", function () {
          arrowIcon.bind("click", function () { $common.togglePageSection(this, callbackFunction, initFunction) });
          sectionHeader.bind("click", function () { $common.togglePageSection(this, callbackFunction, initFunction) });

          if (callbackFunction) {
            window[callbackFunction](clickedElement);
          }
        });
      });
    }
    else {
      arrowIcon.toggleClass("rotate-180");
      content.slideDown("fast", function () {
        horizontalRule.animate({ opacity: 1 }, 1, function () {
          arrowIcon.bind("click", function () { $common.togglePageSection(this, callbackFunction, initFunction) });
          sectionHeader.bind("click", function () { $common.togglePageSection(this, callbackFunction, initFunction) });

          if (callbackFunction) {
            window[callbackFunction](clickedElement);
          }
        });
      });
    }
  },

  getContainerContentHeight: function (containerId) {
    const containerChildren = $("#" + containerId).children();
    let height = 0;

    // Loop container children
    containerChildren.each(function (index, child) {
      const jqChild = $(child);

      // Remove visible children heights when not supplied element
      if (child.tagName && jqChild.outerHeight(true) > 0 && jqChild.is(":visible")) {
        height += jqChild.outerHeight(true);
      }
    });

    return height;
  },

  getNotUsedParentHeightExcludingElement: function (containerId, elementId) {
    // Get container height
    let remainingHeight = $("#" + containerId).outerHeight(true);
    const containerChildren = $("#" + containerId).children();

    // Loop container children
    containerChildren.each(function (index, child) {
      const jqChild = $(child);

      // Remove visible children heights when not supplied element
      if (child.tagName && jqChild.outerHeight(true) > 0 && jqChild.is(":visible")) {
        if (child.id && child.id === elementId) {
          return true;
        }
        remainingHeight = remainingHeight - jqChild.outerHeight(true);
      }
    });

    return remainingHeight;
  },

  setElementToRemainingHeight: function (containerId, elementId) {
    const height = $common.getNotUsedParentHeightExcludingElement(containerId, elementId);
    $("#" + elementId).height(height);
  },

  animateElementToRemainingHeight: function (containerId, elementId, animationDuration) {
    const newHeight = $common.getNotUsedParentHeightExcludingElement(containerId, elementId);

    $("#" + elementId).animate({
      height: newHeight
    }, {
      duration: animationDuration
    });
  },

  hideDueWarning: function () {
    $.ajax({
      suppressErrors: true,
      url: "../Layout/Layout/HideDueWarning",
      type: "POST"
    });
    $(".due-warning-container").remove();
  },

  attachAutoComplete: function (ctrl, pricelistId, includeServiceArticles) {
    const articleNumberTextbox = $(ctrl);
    //Only attach AutoComplete if it hasn't already been attached to this input.
    if (!articleNumberTextbox.hasClass("ui-autocomplete-input")) {
      articleNumberTextbox.autocomplete({
        source: function (request, response) {
          $url.OrderMVC.Order.SearchArticleAutoSuggest.ajax({
            searchText: request.term,
            pricelistId: pricelistId,
            includeServiceArticles: includeServiceArticles
          }, {
            success: function (data) {
              //Get the longest ArticleNo (longest in number of characters). So that it can be used for calculating the space needed 
              //for making the text aligned.
              const longestArticleNo = data.reduce(
                function (result, val) {
                  return Math.max(result, isNaN(val.ArticleNo) ? val.ArticleNo.length : parseInt(val.ArticleNo).toString().length);
                }, 0);

              response($.map(data, function (n, i) {
                //Calculate the number of spaces needed to align the text.
                //For some reason we need to double the padding to get it to align correctly.
                const paddingSize = 2 * (longestArticleNo - n.ArticleNo.toString().length + 1);
                const nonBreakingSpace = "\xa0";

                return {
                  label: n.ShortText,
                  value: n.ArticleNo + $string.repeat(nonBreakingSpace, paddingSize)
                };
              }));
            },
            error: function () { }
          });
        },

        //Set the input value to the ArticleNo when selecting an item.
        select: function (event, ui) {
          //The value has padding because of the aligning, so we need to remove the padding before setting the value on the input.
          const v = ui.item.value.trim();
          this.value = v;

          articleNumberTextbox.blur();
          return false;
        },

        html: true,
        minLength: 3
      })
      .keypress(function (e) {
        if (e.which === 13) {
          $(".ui-menu-item").hide();
        }
      })
      //Override _renderItem so that we're able to use html to style the items.
      .data("ui-autocomplete")._renderItem = function (ul, item) {
        return $("<li></li>")
          .data("item.autocomplete", item)
          .append("<div><span class='FontBold'>" + item.value + "</span>" + item.label + "</div>")
          .appendTo(ul);
      };
    }
  },
}


// Scroll function used in most pages.
jQuery.fn.scrollTo = function (elem, speed) {
  $(this).animate({
    scrollTop: $(this).scrollTop() - $(this).offset().top + $(elem).offset().top - 25
  }, speed === undefined ? 1000 : speed);

  return this;
};

// Polyfill
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}

jQuery.fn.getKendoValidator = function (settings) {
  if (settings) {
    return $(this).kendoValidator(settings).data('kendoValidator');
  }
  return $(this).data('kendoValidator') || $(this).kendoValidator(settings).data('kendoValidator');
}

$(function () {
  // Bind all elements with the label class to show tootip with full text if cut-of by css ellipsis.
  $(document).on('mouseenter', '.label, .k-tooltip', function () {
    const $this = $(this);

    if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
      $this.attr('title', $this.text());
    }
  });

  $(document).on('click', '.k-tooltip-validation', function () {
    $(this).hide();
  });

  //Add global listener for handling "enter" on kendo grids
  $(document).on('keyup', '[data-role=grid][data-continue-on-enter]', function (event) {
    const keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode === 13) {
      $(event.target).blur();
      const td = $(event.target).closest('td');
      const tr = $(td).closest('tr');
      if (tr.hasClass('k-grid-edit-row')) {
        const nextInput = $('input:enabled', td.next('td'));
        if (nextInput.length > 0) {
          nextInput.focus();
        }
        else {
          const kendoGrid = $(event.currentTarget).data('kendoGrid');
          kendoGrid.saveRow();
          if (!kendoGrid.dataSource.options.batch && kendoGrid.dataSource.transport.options && kendoGrid.dataSource.transport.options.create) {
            kendoGrid.one('dataBound', function () {
              kendoGrid.addRow();
            });
          } else {
            kendoGrid.addRow();
          }
        }
      }
    }
    else if (keycode === 27) {
      const kendoGrid = $(event.currentTarget).data('kendoGrid');
      kendoGrid.cancelRow();
    }
  });

  //Add global listener for handling "enter" on kendo grids in forms
  //  - Allow enter if textarea/button/link
  //  - Otherwise don't allow enter in grid
  $(document).on('keydown', 'form [data-role=grid]', function (e) {
    e = e || event;
    const isAnythingButEnter = (e.keyCode || e.which || e.charCode || 0) !== 13;
    if (isAnythingButEnter) {
      // User did not push enter -> allow
      return true;
    }
    const element = (e.target || e.srcElement);
    const isAllowed = /^(textarea|button|a)$/i.test(element.tagName);
    return isAllowed;
  });
});

var $common = compilator.common;